import { DateTime } from 'luxon';

export enum Tier {
    FREE = 'Free',
    BASIC = 'Basic',
    ENTERPRISE = 'Enterprise',
}

export enum Status {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    SUSPENDED = 'Suspended',
}

export type Subscription = {
    licenseId?: string;
    organizationId: string;
    tier: Tier;
    status: Status;
    renewalDate?: DateTime;
    deviceLimit?: number;
    currentDeviceCount: number;
    rateLimit?: number;
};

export type SubscriptionAuditRecord = {
    organizationId: string;
    billingStartDate: string;
    billingEndDate: string;
    deviceOnlineCount: number;
};

export type GetEntitlementForLicenseIdArgs = {
    licenseId: string;
};

export type Entitlement = {
    simpleEntitlement: {
        entitlementId: {
            id: string;
            autoGenerateSpecified: boolean;
        };
        lastModifiedDateTime: string;
        lastModifiedDateTimeSpecified: boolean;
        description: string;
        soldTo: string;
        soldToName: string;
        shipToEmail: string;
        shipToAddress: string;
        emailTemplateVariation: any;
        state: number;
        stateSpecified: boolean;
        createdUserId: string;
        lineItems: Array<{
            productLine: {
                uniqueId: string;
                name: string;
                description: string;
            };
            numberOfRemainingCopies: string;
            fulfilledCount: string;
            availableExtraActivations: string;
            isTrustedType: boolean;
            isTrustedTypeSpecified: boolean;
            state: number;
            stateSpecified: boolean;
            licenseTechnology: {
                uniqueId: string;
                primaryKeys: {
                    name: string;
                };
            };
            parentLineItem: any;
            createdOnDateTime: string;
            createdOnDateTimeSpecified: boolean;
            lastModifiedDateTime: string;
            lastModifiedDateTimeSpecified: boolean;
            overdraftMax: string;
            remainingOverdraftCount: string;
            activationId: {
                id: string;
                autoGenerateSpecified: boolean;
            };
            description: string;
            product: {
                uniqueId: string;
                primaryKeys: {
                    name: string;
                    version: string;
                };
            };
            partNumber: {
                uniqueId: string;
                primaryKeys: {
                    partId: string;
                };
            };
            licenseModel: {
                uniqueId: string;
                primaryKeys: {
                    name: string;
                };
            };
            alternateLicenseModel1: any;
            alternateLicenseModel2: any;
            licenseModelAttributes: object[];
            fnpTimeZoneValue: any;
            policyAttributes: {
                rehostsPolicy: any;
                returnsPolicy: any;
                repairsPolicy: any;
                extraActivationsPolicy: any;
                cancelLicensePolicy: {
                    isCancelLicense: boolean;
                };
                virtualLicensePolicy: {
                    isVirtualLicense: boolean;
                };
                reinstallPolicy: any;
                acpiGenerationIdLicensePolicy: {
                    useACPIGenerationId: boolean;
                };
            };
            orderId: string;
            orderLineNumber: string;
            numberOfCopies: string;
            startDateSpecified: boolean;
            startDateOption: number;
            startDateOptionSpecified: boolean;
            isPermanent: boolean;
            isPermanentSpecified: boolean;
            term: {
                numDuration: string;
                durationUnit: number;
            };
            expirationDateSpecified: boolean;
            versionDateSpecified: boolean;
            versionDateAttributes: any;
            lineItemTypeSpecified: boolean;
            entitledProducts: Array<{
                product: {
                    uniqueId: string;
                    primaryKeys: {
                        name: string;
                        version: string;
                    };
                };
                quantity: string;
            }>;
            lineItemAttributes: Array<{
                attributeName: string;
                stringValue: string;
                dateValueSpecified: boolean;
                booleanValueSpecified: boolean;
                integerValue: any;
                arrayValue: any;
            }>;
        }>;
        maintenanceLineItems: any;
        channelPartners: Array<{
            tierName: string;
            accountUnit: {
                uniqueId: string;
                primaryKeys: {
                    id: string;
                };
            };
            contact: {
                uniqueId: any;
                userName: any;
                primaryKeys: any;
            };
            currentOwner: boolean;
            currentOwnerSpecified: boolean;
        }>;
        allowPortalLogin: boolean;
        allowPortalLoginSpecified: boolean;
        entitlementAttributes: any;
    };
    bulkEntitlement: any;
};

export type GetEntitlementResponse = {
    statusinfo: {
        status: string;
        reason: string;
        total: string;
    };
    entitlement: Entitlement[];
};

export type CreateSubscription = {
    licenseId: string;
    organizationId: string;
};
